const initials = 'coupons/';

export const FETCH_AVAILABLE_COUPONS_REQUEST = `${initials}FETCH_AVAILABLE_COUPONS_REQUEST`;
export const FETCH_AVAILABLE_COUPONS_SUCCESS = `${initials}FETCH_AVAILABLE_COUPONS_SUCCESS`;
export const FETCH_AVAILABLE_COUPONS_FAILURE = `${initials}FETCH_AVAILABLE_COUPONS_FAILURE`;
export const CLEAR_COUPONS = `${initials}CLEAR_COUPONS`;
